import { GridItem } from '@bnnvara/grids';
import PropTypes from 'prop-types';
import React from 'react';

import InfoCard from '../../components/cards/InfoCard';
import Link from '../../components/Link';

const ComposableInfoCard = (props) => {
  const { slug: key, link, index } = props;

  return (
    <GridItem columnEndSm="span 12" columnEndLg="span 6" key={link}>
      <Link
        href={link}
        category="Homepage"
        label={`extra${index}`}
        action="click"
      >
        <InfoCard key={key} {...props} />
      </Link>
    </GridItem>
  );
};

ComposableInfoCard.propTypes = {
  link: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
};

export default ComposableInfoCard;
